// extracted by mini-css-extract-plugin
export default {"configuratorBottomRow":"css_configuratorBottomRow__FAfYx","componentsList":"css_componentsList__uOz+q"};